import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, nextTick } from 'vue'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailRsync',
  props: {
    fleet: null
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
};



const configRsync = computed(() => store.state.fleet.context?.configRsync)

onMounted(() => {
  if (!store.state.fleet.context?.configRsync || store.state.fleet.context.configRsync.idFleet != props.fleet.id) {
    restoreConfigRsync()
  }
})

const saving = ref(false)

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

function restoreConfigRsync() {
  store.state.fleet.context.configRsync = {
    idFleet: props.fleet.id,
    login: '',
    password: '',
    port: 22,
    server: '',
    sftp: true,
    dstPaths: '',
    syncPaths: [],
    privateKey: ''
  }
}

async function applyToAll() {
  if (saving.value) return
  saving.value = true

  for (const mission of missions.value.filter((m) => m.misActifOn)) {
    if (mission.gliId == null) return
    try {
      await store.myActions.GLIDER_IRIS_RSYNC_REQUEST(mission.gliId!)
      await store.myActions.GLIDER_UPDATE_MODIFIED_RSYNC({
        itemId: mission.gliId!,
        newProperties: {
          mod_settings: {
            RSync_remote: {
              dst_paths: configRsync.value.dstPaths,
              login: configRsync.value.login,
              password: configRsync.value.password,
              port: configRsync.value.port,
              private_key: configRsync.value.privateKey,
              server: configRsync.value.server,
              sftp: configRsync.value.sftp,
              sync_paths: configRsync.value.syncPaths.filter((p: any) => SyncPathsArr.some((pa) => pa == p))
            }
          }
        }
      })
      await store.myActions.GLIDER_IRIS_RSYNC_SAVE_REQUEST(mission.gliId!)
    } catch (e) {
      console.error(e)
    }
  }
  nextTick(() => {
    restoreConfigRsync()
    saving.value = false
  })
}

return { __sfc: true,props, configRsync, saving, missions, restoreConfigRsync, applyToAll, SyncPathsArr }
}

})